import { Component, computed, inject, Signal, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import TYPES from '../../constants/types';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ButtonComponent } from "../../components/button/button.component";
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AUTH_SERVICE, AuthService } from '../../services/auth.service';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'app-info',
  imports: [
    TranslatePipe,
    ButtonComponent,
    MatSnackBarModule,
    MatProgressBarModule
],
  templateUrl: './info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './info.component.scss'
})
export class InfoComponent {

  type:string | undefined;
  highlight:string | undefined;
  info:string | undefined;
  message:string | undefined;
  buttonLabel: string | undefined;
  params: Params | undefined;

  INFO_SCREEN:any;
  BUTTON_TYPES:any;

  disabled:WritableSignal<boolean> = signal(false);
  readonly INITIAL_TIME:number = 90;
  countdown:WritableSignal<number> = signal(this.INITIAL_TIME);
  countdownProgress: Signal<number> = computed(() => ((this.INITIAL_TIME - this.countdown()) / this.INITIAL_TIME) * 100);

  authService:AuthService = inject(AUTH_SERVICE);
  snackBar:MatSnackBar = inject(MatSnackBar);
  translate: TranslateService = inject(TranslateService);

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ){
    this.INFO_SCREEN = TYPES.UI.INFO_SCREEN;
    this.BUTTON_TYPES = TYPES.UI.BUTTON;

    this.type = this.route.snapshot.paramMap.get('type')!;
    this.highlight = this.route.snapshot.paramMap.get('highlight')!;
    this.info = this.route.snapshot.paramMap.get('info')!;
    this.message = this.route.snapshot.paramMap.get('message')!;
    this.buttonLabel = this.route.snapshot.paramMap.get('button-label')!;

    this.route.queryParams.subscribe(params => {
      this.params = params;
    });

    if(
      this.type === this.INFO_SCREEN.ACCOUNT_CREATED
      || this.type === this.INFO_SCREEN.EMAIL_VERIFICATION_PENDING
    ){
      this.disabled.set(true);
      this.startResendEmailCountdown();
    }

  }

  async continue(){
    if(
      this.type === this.INFO_SCREEN.ACCOUNT_CREATED
      || this.type === this.INFO_SCREEN.EMAIL_VERIFICATION_PENDING
    ){
      if(this.params && this.params['email']){
        const error = await this.authService.resendConfirmationEmail(this.params['email']);
        if(!error){

          const message:string = this.translate.instant('info.resent_email');
          const action:string = this.translate.instant('buttons.dismiss');
          this.snackBar.open(message, action);

          this.disabled.set(true);
          this.countdown.set(this.INITIAL_TIME);
          this.startResendEmailCountdown();

        }
      }
    }else if (this.type === this.INFO_SCREEN.SUCCESS
      || this.type === this.INFO_SCREEN.SUBSCRIPTION_DONE
    ){
      this.router.navigate(['/'], { replaceUrl: true });
    }
  }

  private startResendEmailCountdown() {
    const interval = setInterval(() => {
      const newValue = this.countdown() - 1;
      this.countdown.set(newValue);
      if (newValue <= 0) {
        this.disabled.set(false);
        clearInterval(interval);
      }
    }, 1000);
  }

}
